<div class="loading-overlay" #spinnerElement *ngIf="showLoader">
    <mat-spinner color="accent"></mat-spinner>
</div>
<router-outlet></router-outlet>